import types from '../types/start'
// import timeslotActions from './calendar'
import {TRANSACTIONS} from '../../../endpoints'
import {apiPrivate} from '../../../api'
// import moment from '../../../common/moment'
import {endpoint as endpointText} from '../../../common/text'
import {push} from 'react-router-redux'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class start {

  static getTransaction() {
    return function(dispatch) {

      dispatch({type: types.GET_TRANSACTION})

      apiPrivate.get(TRANSACTIONS + '/transactions/created?type=3')
        .then(response => {
          dispatch(start.getTransactionSuccess(response.data.description))
          // if (response.data.description.Reserve.Date !== '0001-01-01T00:00:00Z') {
          //   dispatch(timeslotActions.selectDate(moment.utc(response.data.description.Reserve.Date)))
          // } else {
          //   dispatch(timeslotActions.selectDate(moment()))
          // }
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(start.getTransactionFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(start.getTransactionFail(message))
        })
    }
  }

  static getTransactionSuccess(data) {
    return {
      type: types.GET_TRANSACTION_SUCCESS,
      payload: {
        transaction: data,
      },
    }
  }

  static getTransactionFail(error) {
    return {
      type: types.GET_TRANSACTION_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/depositV2/actions/start.js